import { Vue, Component, Prop } from 'vue-property-decorator'
import { default as TReview } from '~/types/api/Review'
import Review from '~/components/block/Review'
import NoReviews from '~/components/block/NoReviews'
import Btn from '~/components/element/Btn'
import s from '~/utils/s'
import SectionHelper from '~/utils/sectionHelper'

@Component
export default class ProductReviews extends Vue {
  @Prop({ required: true, type: Array })
  readonly reviews!: TReview[]

  @Prop({ type: Object })
  readonly userReview?: TReview

  isShowReviewBtn (): boolean {
    const { canReview, canUserReview } = s(this.$store).productPage
    const { isAuth } = s(this.$store).auth

    return canReview && (!isAuth || (isAuth && canUserReview))
  }

  showReviewPopup (event: MouseEvent) {
    event.stopPropagation()
    s(this.$store).reviewsPage.showPopup()
  }

  renderShowMoreButton () {
    const { sectionId, id } = s(this.$store).productPage
    const helper = new SectionHelper(s(this.$store).general.sections, this.$store)

    const link = helper.getProductLink(sectionId?.length ? sectionId[0] : s(this.$store).categoryPage.category.id, id) + 'reviews/' // TODO: добавить seoUrl

    return (
      <nuxt-link to={link}
        class="entity-list-block__content-fetch-button product-page-reviews__btn-link"
      >
          Посмотреть все отзывы
      </nuxt-link>
    )
  }

  renderOpenReviewPopupBtn () {
    return (
      <Btn {...{
        props: {
          label: this.userReview?.id ? 'Изменить свой отзыв' : 'Оставить отзыв',
          type: 'button'
        },
        nativeOn: {
          click: this.showReviewPopup
        }
      }} />
    )
  }

  renderReviewsList () {
    return (
      <div class="product-page-reviews__list">
        { this.reviews.map(review => <Review {...{ props: { review } }} />) }
      </div>
    )
  }

  render () {
    return (
      <div class="product-page-reviews">
        <div class="product-page-reviews__row">
          <div class="product-page-reviews__col-nav">
            {/* {this.propertyList.length >= 2 && this.renderNavigation()} */}
          </div>
          <div class="product-page-reviews__col-content">
            <div class="product-page-reviews__header">
              <h2 class="product-page-reviews__header-title">Отзывы</h2>

              { this.reviews.length
                ? <div class="product-page-reviews__desktop">
                  { this.isShowReviewBtn() && this.renderOpenReviewPopupBtn() }
                </div>
                : ''
              }
            </div>

            <div class="product-page-reviews__body">
              { this.reviews.length > 0 && this.renderReviewsList() }
              { this.reviews.length === 0 && <NoReviews /> }
            </div>

            <div class="product-page-reviews__footer">
              { this.reviews.length ? this.renderShowMoreButton() : ''}

              <div class="product-page-reviews__mobile">
                { this.isShowReviewBtn() && this.renderOpenReviewPopupBtn() }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
